import * as React from "react";
import { action } from "mobx";
import { inject, observer } from "mobx-react";
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { AppProps } from "../../stores/storeContract";
import bitfinexLogo from "../../assets/images/Bitfinex.png";
import "./Scanner.scss";
import Chart from "../chart/Chart";
import Trades from "../trades/Trades";
import scannerHelper from "../../helpers/scannerHelper";
import TradesPreview from "../trades/TradesPreview";
import TradesPreviewVerticalArrows from "../trades/TradesPreviewVerticalArrows";

const globalVariables = require('globalVariables');

@inject("commonStore", "scannerStore", "formatStore", "notificationStore", "settingsStore", "symbolStore")
@observer
export default class Scanner extends React.Component<AppProps> {
    
    private connection: HubConnection;
    private titleTimerId: NodeJS.Timeout;

    componentDidMount() {

        this.connection = new HubConnectionBuilder()
            .withUrl(globalVariables.apiUrl + '/appHub?username=' + window.localStorage.getItem('userName'))
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();
        this.connection.on("sc", (data: any) => {
            console.log(data);
            if (data) {               
                var newChanges = JSON.parse(data);
                this.props.scannerStore.setChanges(newChanges);
            }          
        });
        this.connection.on("pc", (data: any) => {
            console.log(data);
            if (data) {               
                var newPosts = JSON.parse(data);
                console.log(newPosts);
                this.props.notificationStore.setPosts(newPosts);
            }          
            
        });
        this.connection.start();

        this.titleTimerId = setInterval(this.onTitleTimerElapsed, 5000);
    }

    componentWillUnmount() {
        this.connection.stop();

        if (this.titleTimerId != null)
            clearInterval(this.titleTimerId);
    }

    @action.bound onTitleTimerElapsed(): void {
        var utcTime = (new Date()).getTime();
        var title = this.props.notificationStore.title;
        
        if (title && title.validUntil < utcTime) {
            this.props.notificationStore.clearTitle();
        }
    }

    @action navigateToBitfinex(symbol: string): void {
        var symbolNameDetail = this.props.symbolStore.symbolNameDetails.find(snd => snd.symbol == symbol);
        if (symbolNameDetail) {
            var url = 'https://www.bitfinex.com/t/' + symbolNameDetail.baseShort + ':' + symbolNameDetail.quoteShort;
            window.open(url, "_blank");
        }
    }   

    render() {

        const { isMobile } = this.props.commonStore;        
        const { clearRecentChanges, actualChanges, recentChanges, rerenderFlag } = this.props.scannerStore; // leave rerenderFlag here to force UI render
        const { formatInterval, formatChange, formatTimeAgo, formatNumber } = this.props.formatStore;
        const { formatSymbol, formatSymbolBase, formatSymbolQuote } = this.props.symbolStore;
        const { defaultQuote, volumeDefaultView, extendedRowVisible } = this.props.settingsStore;

        console.log('rendering');

        var tradesPropsStatic = {
            symbol: 'tBTCUSD',
            trades: [{
                id: 1,                
                timestamp: new Date(2022,3,24,7,56,41,0),
                amount: 1,
                price: 44500,
                usd: 44500
            },{
                id: 2,                
                timestamp: new Date(2022,3,24,7,57,42,0),
                amount: 2,
                price: 44100,
                usd: 89000
            },{
                id: 3,                
                timestamp: new Date(2022,3,24,7,58,43,0),
                amount: 0.5,
                price: 44122,
                usd: 22066
            },{
                id: 4,                
                timestamp: new Date(2022,3,24,7,59,44,0),
                amount: 1,
                price: 45010,
                usd: 45010
            },
            ,{
                id: 5,                
                timestamp: new Date(2022,3,24,7,59,45,0),
                amount: 1,
                price: 45010,
                usd: 45010
            }
            ,{
                id: 6,                
                timestamp: new Date(2022,3,24,7,59,46,0),
                amount: 1,
                price: 45010,
                usd: 45010
            }],
            highlightTradeIds: [1,3,4],
            ...this.props
        }
      
        return (
            <div className="scanner">
                <div className="row no-gutters">
                    <div className="col-md-6 no-padding">
                        <div className="scanner-panel">                            
                            <div className="scanner-table">
                                <table className="table table-sm">
                                    <tbody>
                                        <tr className={actualChanges.length > 0 ? 'hidden' : 'scanner-no-changes'}>
                                            <td>No new changes</td>
                                        </tr>
                                        { 
                                            actualChanges.map((ch, index) => {

                                                var keyPrefix = 'ac_' + ch.symbol;
                                                var keyIteration = 0;

                                                var chartProps = {
                                                    symbol: ch.symbol,
                                                    interval: Math.min(...ch.items.map(i => { return i.interval; })),
                                                    ...this.props
                                                }

                                                var currentExtendedRowVisible = extendedRowVisible && index < 2;

                                                var lowestInterval = Math.min(...ch.items.map(i => i.interval));
                                                var lowestIntervalChangeTrades = scannerHelper.selectMany(
                                                    ch.items.filter(i => i.interval == lowestInterval),
                                                    i => i.changeTrades
                                                );
                                                
                                                var tradesProps = {
                                                    symbol: ch.symbol,
                                                    trades: ch.trades,
                                                    highlightTradeIds: lowestIntervalChangeTrades.map(t => t.id),
                                                    ...this.props
                                                }

                                                var lastTradeIndex = ch.trades.length - 1;
                                                var lastTrade = lastTradeIndex >= 0 ? ch.trades[lastTradeIndex] : null;

                                                var volumeCurrency = defaultQuote;
                                                if (volumeDefaultView == 0)
                                                    volumeCurrency = formatSymbolQuote(ch.symbol);
                                                if (volumeDefaultView == 1)
                                                    volumeCurrency = formatSymbolBase(ch.symbol);

                                                return [                                           
                                                    <tr key={keyPrefix} className="scanner-item">
                                                        <td>                                                            
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <button className="btn scanner-action-btn" onClick={() => this.navigateToBitfinex(ch.symbol)}>
                                                                                <img src={bitfinexLogo} 
                                                                                    alt="Bitfinex" 
                                                                                    className="scanner-action-icon" />                                                                                                                                                  
                                                                            </button>
                                                                            <strong className="change-label">{formatSymbol(ch.symbol)}</strong>
                                                                        </div>
                                                                        <div className="col-md-12 font-smaller">
                                                                            <span style={{ paddingLeft: '28px' }}></span>
                                                                            Last: 
                                                                            <span className={lastTrade != null ? '' : 'hidden'}>
                                                                                <strong> {formatNumber(lastTrade.price, 8)}</strong>
                                                                            </span>
                                                                            <span className={lastTrade != null ? 'hidden' : ''}>
                                                                                <strong> N/A</strong>
                                                                            </span>                                                                            
                                                                        </div>
                                                                        <div className="col-md-12 font-smaller">
                                                                            <span style={{ paddingLeft: '28px' }}></span>
                                                                            24 Vol: <strong>{formatNumber(ch.volumeDailyChange, 0)}</strong> {volumeCurrency}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={isMobile ? 'col-md-12': 'hidden'} style={{height: '10px'}}></div>
                                                                <div className="col-md-8">
                                                                    <table width="100%">
                                                                        <tbody>
                                                                        {
                                                                            ch.items.map(i => {
                                                                                return (
                                                                                    <tr key={keyPrefix + '_' + keyIteration++}>
                                                                                        <td>
                                                                                            <div
                                                                                                className="filter-icon"
                                                                                                style={{borderLeft: '3px solid ' + i.filterColorCode}}>#{i.filterIndex}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <div>{formatInterval(i.interval)}</div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <div>+{formatNumber(i.volumeIntervalChange, 0)} {volumeCurrency}</div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <div className={isMobile ? 'scanner-change' : 'scanner-change-large'}>
                                                                                            { i.minPriceChangePercentage != i.maxPriceChangePercentage ? (
                                                                                                <div
                                                                                                    className={i.minPriceChangePercentage > 0 ? 'color-green' : 'color-red'}>
                                                                                                        {formatChange(i.minPriceChangePercentage)}% to {formatChange(i.maxPriceChangePercentage)}%
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div                                                                                   
                                                                                                    className={i.priceChangePercentage > 0 ? 'color-green' : 'color-red'}>
                                                                                                        {formatChange(i.priceChangePercentage)}%
                                                                                                </div>
                                                                                            )}
                                                                                            </div>                                                                                                
                                                                                        </td>
                                                                                        
                                                                                    </tr>
                                                                                );
                                                                            })
                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="col-md-7" style={{ display: currentExtendedRowVisible ? 'block' : 'none' }}>
                                                                    <Chart {...chartProps} />
                                                                </div>
                                                                <div className="col-md-5" style={{ display: currentExtendedRowVisible && !isMobile ? 'block' : 'none' }}>
                                                                <TradesPreviewVerticalArrows {...tradesProps} />
                                                                </div>  
                                                            </div>                                                        
                                                        </td>                                                        
                                                    </tr>,
                                                    <tr key={keyPrefix + '_tr'} className="empty-thin-row"></tr>
                                                ];                                           
                                            }) 
                                        }

                                                {/* <tr className="scanner-item">
                                                        <td>                                                            
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    
                                                                </div>
                                                              
                                                                <div className="col-md-8">
                                                                    
                                                                </div>
                                                                <div className="col-md-7" >
                                                                    
                                                                </div>
                                                                <div className="col-md-5">
                                                                <TradesPreviewVerticalArrows {...tradesPropsStatic} />
                                                                </div>  
                                                            </div>                                                        
                                                        </td>                                                        
                                                    </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 no-padding">
                        <div className="scanner-panel">                           
                            <div className="scanner-table">
                                <table className="table table-sm">
                                    <tbody>                                        
                                        { 
                                            recentChanges.map(ch => {

                                                var keyPrefix = 'rc_' + ch.symbol;
                                                var keyIteration = 0;
                                                
                                                return [                                           
                                                    <tr key={keyPrefix} className="scanner-item">
                                                        <td>
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <button className="btn scanner-action-btn" onClick={() => this.navigateToBitfinex(ch.symbol)}>
                                                                        <img src={bitfinexLogo} 
                                                                            alt="Bitfinex" 
                                                                            className="scanner-action-icon" />                                                              
                                                                    </button>
                                                                    <strong className="change-label">{formatSymbol(ch.symbol)}</strong>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <table width="100%">
                                                                        <tbody>
                                                                        {
                                                                            ch.items.map(i => {
                                                                                return (
                                                                                    <tr key={keyPrefix + '_' + keyIteration++}>
                                                                                        <td width="10%">
                                                                                            <div
                                                                                                className="filter-icon"
                                                                                                style={{borderLeft: '3px solid ' + i.filterColorCode}}>#{i.filterIndex}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td width="10%">
                                                                                            <div>{formatInterval(i.interval)}</div>
                                                                                        </td>                                                                                               
                                                                                        <td width="50%">
                                                                                            <div className="scanner-change">
                                                                                            { i.minPriceChangePercentage != i.maxPriceChangePercentage ? (
                                                                                                <div
                                                                                                    className={i.minPriceChangePercentage > 0 ? 'color-green' : 'color-red'}>
                                                                                                        {formatChange(i.minPriceChangePercentage)}% to {formatChange(i.maxPriceChangePercentage)}%
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div                                                                                    
                                                                                                    className={i.priceChangePercentage > 0 ? 'color-green' : 'color-red'}>
                                                                                                        {formatChange(i.priceChangePercentage)}%
                                                                                                </div>
                                                                                            )}
                                                                                            </div>                                                                                                
                                                                                        </td>
                                                                                        <td width="30%">
                                                                                            <div>
                                                                                            <i className="far fa-clock"></i> {formatTimeAgo(i.validFrom)}</div>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })
                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </td>                                                        
                                                    </tr>,
                                                     <tr key={keyPrefix + '_tr'} className="empty-thin-row"></tr>
                                                ];                                           
                                            }) 
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <button className="btn btn-outline-secondary btn-sm float-right" style={{ display: recentChanges.length ? 'initial' : 'none' }} onClick={clearRecentChanges}>
                                <i className="fas fa-trash"></i> Clear
                            </button>
                        </div>
                    </div>
                </div>        
            </div>
        );
    }
}